import React from "react";
import { sortableHandle } from "react-sortable-hoc";
import UnfoldMore from "@material-ui/icons/UnfoldMore";

const DragHandle = ({ classes }) => (
  <UnfoldMore className={classes.icon} color="secondary" />
);

export default sortableHandle(DragHandle);
